import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  name: "addInterface",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      formModel: {
        mod_code: null,
        res_name: null,
        state: 1,
        res_desc: null
      },
      formRules: {
        mod_code: [{
          required: true,
          message: '请选择所属模块',
          trigger: 'blur'
        }],
        res_name: [{
          required: true,
          message: '请输入接口名称',
          trigger: 'change'
        }],
        res_desc: [{
          required: true,
          message: '请输入接口说明',
          trigger: 'blur'
        }],
        state: [{
          required: true,
          type: 'number',
          message: '请选择状态',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {},
    moduleData: {}
  },
  components: {},
  computed: {},
  methods: {
    init: function init() {}
  },
  mounted: function mounted() {},
  created: function created() {
    this.init();

    if (this.edit) {
      Object.assign(this.formModel, this.setData);
    }
  }
};